import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {PageContent} from 'aui-react';

import Row from './Row';
import {commonPropTypes} from '../../../constants/';

export class WarningRows extends PureComponent {
    static propTypes = {
        warnings: PropTypes.arrayOf(commonPropTypes.event),
    };

    static defaultProps = {
        warnings: [],
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    render() {
        if (this.props.warnings.length === 0) {
            return null;
        }

        const helpLinkText = this.context.i18n('johnson.check.events.event.kblink');

        return (
            <PageContent>
                <div className="warning-row">
                    {this.props.warnings.map((event, index) => (
                        <Row key={index} event={event} helpLinkText={helpLinkText} /> // eslint-disable-line react/no-array-index-key
                    ))}
                </div>
            </PageContent>
        );
    }
}

const mapStateToProps = state => ({
    warnings: state.events.newEvents.warning,
});

export default connect(mapStateToProps)(WarningRows);



// WEBPACK FOOTER //
// ./src/components/NewEventsTable/Rows/WarningRows.js